import { render, staticRenderFns } from "./feizheng.vue?vue&type=template&id=05184ff2"
import script from "./feizheng.vue?vue&type=script&lang=ts"
export * from "./feizheng.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports